module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1070.1c1f25f2.png";